function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import featureEnabled from 'shared/helper/feature';
var linkStartsWithLanguage = function linkStartsWithLanguage(link) {
  return !!link.match(/^\/(cn|jp|en|br|es)\//);
};
var prependLanguageToLink = function prependLanguageToLink(siteLanguage, link) {
  var restrictLanguages = featureEnabled('rubriq_restrict_languages');
  var normalizedLanguage = restrictLanguages && !['en', 'cn'].includes(siteLanguage) ? 'en' : siteLanguage;
  if (!normalizedLanguage) {
    return link;
  }
  if (typeof link === 'string') {
    if (link.indexOf('/api') !== -1) {
      return link;
    }
    if (linkStartsWithLanguage(link)) {
      if (restrictLanguages && link.match(/^\/(jp|br|es)\//)) {
        return link.replace(/^\/(jp|br|es)\//, '/en/');
      }
      return link;
    }
    return "/".concat(normalizedLanguage).concat(link);
  }
  if (linkStartsWithLanguage(link.pathname)) {
    if (restrictLanguages && link.pathname.match(/^\/(jp|br|es)\//)) {
      return _objectSpread(_objectSpread({}, link), {}, {
        pathname: link.pathname.replace(/^\/(jp|br|es)\//, '/en/')
      });
    }
    return link;
  }
  return _objectSpread(_objectSpread({}, link), {}, {
    pathname: "/".concat(normalizedLanguage).concat(link.pathname)
  });
};
export default prependLanguageToLink;